import { fromActivityEvalRuntimeWire, fromInstanceActivityEvalEnvelopeWire } from "../activity-evals/instance/instance-eval-wire.js";
import { ActivityEvalInstanceDisplay } from "../activity-evals/instance/ActivityEvalInstanceDisplay.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/instance/ServicePeriodInstanceEvals.tsx
function envelopeKey(item, index) {
	return item.id ?? `eval-${index}`;
}
function runtimeKey(item, index) {
	return item.id ?? item.envelopeId ?? `eval-${index}`;
}
function ServicePeriodInstanceEvals({ activityEvals, periodEndsAt, periodStartsAt, runtimeActivityEvals, timezone }) {
	if (runtimeActivityEvals?.length) return /* @__PURE__ */ jsx("div", {
		className: "mt-xs flex flex-col gap-xs",
		children: runtimeActivityEvals.map((item, index) => /* @__PURE__ */ jsx(ActivityEvalInstanceDisplay, {
			activityEval: fromActivityEvalRuntimeWire(item),
			periodEndsAt,
			periodStartsAt,
			timezone
		}, runtimeKey(item, index)))
	});
	if (!activityEvals?.length) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "mt-xs flex flex-col gap-xs",
		children: activityEvals.map((item, index) => /* @__PURE__ */ jsx(ActivityEvalInstanceDisplay, {
			activityEval: fromInstanceActivityEvalEnvelopeWire(item),
			periodEndsAt,
			periodStartsAt,
			timezone
		}, envelopeKey(item, index)))
	});
}
//#endregion
export { ServicePeriodInstanceEvals };

//# sourceMappingURL=ServicePeriodInstanceEvals.js.map